import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

declare var $: any;

export class Home {

  constructor(private _router: Router) {
    if (!sessionStorage.getItem(environment.atoken))
      this._router.navigate(['/login']);
  }

  public allowAcess(status) {
    if (status == 401) {
      sessionStorage.removeItem(environment.atoken);
      this._router.navigate(['/login']);
    }
  }

  public openMessenge(reason, t) {
    $.notify({
      icon: "pe-7s-info",
      message: reason
    }, {
        type: t, /** 'info','success','warning','danger' */
        timer: 1500,
        placement: {
          from: 'top',
          align: 'right'
        }
      });
  }

  public goHome() {
    this._router.navigate(['./home/dashboard']);
  }

  public isAdmin() {
    return true;
  }
}